import mfaEvents from "./events/MFAEvents";
import AccessibilityUtil from "core-ui/client/src/app/core/util/AccessibilityUtil";
import ExternalLogger from "core-ui/client/src/app/ExternalLogger";

var mfaVerifyCodeController = function (
    $cookies,
    $rootScope,
    $scope,
    $window,
    AccuCodeService,
    DefaultCustomizationRetrService,
    PreLoginAccuRetrievalService,
    ReSetACCUService,
    PreLoginContactInfoService,
    eventBus,
    mfaFactory,
    redirectService
) {
    const logger = ExternalLogger.getInstance("mfaVerifyCodeController");
    $scope.mfa = {};
    $scope.verificationMessage = '';
    $scope.verification = {
        verificationCode: '',
        rememberDevice: ''
    };
    $scope.submitted = false;
    $scope.getFormGroupClass = function (fieldName) {
        var field = $scope.verficationForm[fieldName];
        var status = '';

        if (field.$invalid && field.$dirty) {
            status = 'has-error';
        }

        if (field.$invalid && $scope.verficationForm.$submitted) {
            status = 'has-error';
        }

        return status;
    };

    $scope.displayFieldError = function (fieldName) {
        var field = $scope.verficationForm[fieldName];
        var displayFieldError = false;

        if (field.$invalid && field.$dirty) {
            displayFieldError = true;
        }

        if (field.$invalid && $scope.verficationForm.$submitted) {
            displayFieldError = true;
        }

        return displayFieldError;
    };

    $scope.getFieldError = function (fieldName) {
        return $scope.verficationForm[fieldName].$error;
    };

    var updateCssAccu = function (val) {
        if (val) {
            $rootScope.css.accu = val;
            globalThis.css.accu = val;
        } else {
            $rootScope.css.accu = $window.accu;
            globalThis.css.accu = $window.accu;
        }
    };

    $scope.verifyCode = function (flowName) {
        var method = 'mfaVerifyCodeController verifyCode'
        eventBus.dispatch(mfaEvents.SIGN_IN, this);
        $scope.showSpinner = true;
        // Check if the form input is valid
        if ($scope.verficationForm.$valid) {
            if ($scope.verification.rememberDevice === undefined || $scope.verification.rememberDevice === '') {
                $scope.verification.rememberDevice = 'false';
            }

            var verificationData = {
                "verificationCode": $scope.verification.verificationCode,
                "rememberDevice": $scope.verification.rememberDevice,
                "flowName": $rootScope.flowName
            };

            mfaFactory.verifyCode.query(verificationData,

                function (data, headers) {
                    $scope.showSpinner = true;
                    if (data.errors === false) {
                        $scope.mfa.errorMessage = '';
                        if (data.primaryPlan && data.primaryPlan.accuCode) {
                            var newAccuCode = data.primaryPlan.accuCode;
                            //set gaId 
                            if (!$rootScope.gaId) {
                                $rootScope.gaId = data.primaryPlan.gaId;
                            }
                            if (newAccuCode && ($window.accu !== newAccuCode) &&
                                ($window.supportedACCU.folders.indexOf(newAccuCode) >= 0)) {
                                logger.error('{0} - Empower Restricted authentication..changing accu to [{1}]', [method, newAccuCode]);
                                $window.accu = newAccuCode;
                                global.accu = newAccuCode;

                                //update tomcat
                                logger.error('{0} - updating accu...', [method]);
                                ReSetACCUService.query({ accu: $window.accu }).$promise.then(function (resetAccuData) {
                                    //set cookie
                                    $cookies.remove('accu', { path: '/' });
                                    $cookies.put('accu', $window.accu, { path: '/' });
                                    $cookies.remove('accu', { path: '/participant' });
                                    $cookies.put('accu', $window.accu, { path: '/participant' });
                                    $cookies.remove('clientAccu', { path: '/' });
                                    $cookies.put('clientAccu', $window.accu, { path: '/' });
                                    $cookies.remove('clientAccu', { path: '/participant' });
                                    $cookies.put('clientAccu', $window.accu, { path: '/participant' });

                                    // added to resolve SR # 03597037   - cookie used for legacy pptweb quicken download feature 
                                    $cookies.remove('PM-ACCU-TOKEN', { path: '/' });

                                    $scope.accu = AccuCodeService.getAccuCode();

                                    updateCssAccu($scope.accu);
                                    //to reload customizations..

                                    console.log(method + '- re-loading default customizations..', method);
                                    DefaultCustomizationRetrService.query().$promise.then(function (defaultData) {
                                        console.log(method + '- default customizations..', method, defaultData);

                                        console.log(method + '- re-loading preLogin accu data..', method);
                                        PreLoginAccuRetrievalService.query({ accu: $scope.accu }).$promise.then(function (preLoginData) {
                                            console.log(method + '- preLogin accu data..', method, preLoginData);
                                            $scope.accuCustomization = angular.extend({}, defaultData, preLoginData);
                                            $rootScope.accuSpecificPrimDb = $scope.accuCustomization.primaryDatabase.preLoginPrimaryDB;

                                            console.log(method + '- re-loading PreLogin contact info..', method);
                                            console.log(method + '- existing siteContactInfo', $rootScope.siteContactInfo);
                                            PreLoginContactInfoService.query({ accu: accu, accuSpecificPrimDb: $rootScope.accuSpecificPrimDb, portalType: 'TOLLFREE' }).$promise.then(function (contactData) {
                                                $rootScope.siteContactInfo = contactData;
                                                console.log(method + '-  NEW PreLogin contact info..', method, contactData);
                                                $rootScope.$broadcast('siteContactInfoUpdated', $rootScope.siteContactInfo);
                                                $rootScope.$broadcast('loginAuthStatusVerified', $scope.authenticationStatus);
                                                $rootScope.$broadcast('customizationUpdated', $scope.accuCustomization);

                                                logger.error('{0} - Accu code reset to: [{1}]', [method, $scope.accu]);
                                                //#############################################################################
                                                // $window.location.href = "../../participant/#/mfa/activationCodeDeliveryOptions?accu="+$scope.accu;
                                                redirectService.redirect(data, 'ALL', 'MFA');
                                                //#############################################################################
                                            });
                                        });
                                    });
                                });
                            } else {
                                redirectService.redirect(data, 'ALL', 'MFA');
                            }
                        } else {
                            redirectService.redirect(data, 'ALL', 'MFA');
                        }
                    } else {
                        $scope.verificationMessage = data.activationCode;
                        $scope.showSpinner = true;
                    }

                },
                function (response) {
                    $scope.showSpinner = false;
                    $scope.mfa.errorMessage = '';
                    $scope.verificationMessage = "";

                    if (response.headers('exception') !== null) {
                        $scope.mfa.errorMessage = response.data.error.code;
                        $scope.mfa.errorMessageParams = response.data.error.errors[0];

                    } else {
                        $scope.mfa.errorMessage = '99999';

                    }
                });
        } else {
            $scope.showSpinner = false;
            // focus the error message for screen readers
            AccessibilityUtil.focusElement('screenReader');
        }
    };


    // focus the input with an error
    $scope.focusOnErrorInput = function (e, elementId) {
        AccessibilityUtil.focusOnErrorInput(e, elementId);
    };
};


mfaVerifyCodeController.$inject = [
    '$cookies',
    '$rootScope',
    '$scope',
    '$window',
    'AccuCodeService',
    'DefaultCustomizationRetrService',
    'PreLoginAccuRetrievalService',
    'ReSetACCUService',
    'PreLoginContactInfoService',
    'eventBus',
    'mfaFactory',
    'redirectService'
];
export default mfaVerifyCodeController;

